import type {ReservationSearchData} from "./ReservationSearchData";

export class RoomPeopleConfiguration {
    constructor() {
        this.uniqueId = RoomPeopleConfiguration.nextId++;
    }

    adultCount: null | number = 1;
    childrenAges: number[] = [];
    uniqueId: number = 0;
    static nextId = 1;

    get childrenCount(): number {
        return this.childrenAges.length;
    }

    set childrenCount(newCount: number) {
        if (!newCount) {
            this.childrenAges = [];
        } else {
            for (let i = 0; i < newCount; i++) {
                if (this.childrenAges.length <= i) {
                    this.childrenAges[i] = 5;
                }
            }
            this.childrenAges.length = newCount;
        }
    }

    getConfigurationId(): string {
        return RoomPeopleConfiguration.getConfigurationId(this.adultCount as number, this.childrenAges);
    }

    /**
     * Zwraca id konfiguracji osób
     */
    static getConfigurationId(adultCount: number, childrenAges: number[]): string {
        let configurationId = adultCount.toString() + ';';
        if (childrenAges) {
            childrenAges.sort((a, b) => a - b);
            configurationId += childrenAges.join(',');
        }
        return configurationId;

    }

    static fromReservationData(reservationData: ReservationSearchData): RoomPeopleConfiguration {
        const result = new RoomPeopleConfiguration();
        result.adultCount = reservationData.adultCount;
        result.childrenCount = reservationData.childrenAges?.length || 0;
        result.childrenAges = reservationData.childrenAges;
        result.uniqueId = 1;
        return result;
    }

    static fromConfigurationId(configurationId: string): RoomPeopleConfiguration {
        const result = new RoomPeopleConfiguration();
        const parts = configurationId.split(';');
        result.adultCount = parseInt(parts[0]);
        if (parts[1]) {
            result.childrenAges = parts[1].split(',').map(parseInt);
        }
        return result;
    }

    static getNextId() {
        return this.nextId++;
    }
}